import { z } from "zod";
import { HashedIdSchema } from "./schemas";
import { IQuestionnaireMinimalSchema, IQuestionSchema } from "@Features/questionnaireBuilder/domain/schemas";

const IAnswerSchema = z.object({
    answerId: HashedIdSchema,
    questionId: HashedIdSchema,
    choiceId: HashedIdSchema,
});

export type IAnswer = z.infer<typeof IAnswerSchema>;
export type IQuestionnaireMinimal = z.infer<typeof IQuestionnaireMinimalSchema>;

export const IQuestionnaireInstanceMinimalSchema = z.object({
    questionnaireId: HashedIdSchema,

    title: z.string(),
});

export type IQuestionnaireInstanceMinimal = z.infer<typeof IQuestionnaireInstanceMinimalSchema>;

const IAnswerableQuestionSchema = IQuestionSchema.omit({ questionnaireId: true }).extend({
    answer: z.string().optional(),
});

export const IQuestionnaireInstanceSchema = z.object({
    questionnaireInstanceId: HashedIdSchema,
    questionnaireId: HashedIdSchema,
    title: z.string(),
    learningObjectiveDetails: z.object({
        description: z.string(),
        learningObjectiveId: HashedIdSchema,
    }),
    questions: z.array(IAnswerableQuestionSchema),
    completedOn: z.string().datetime().optional(),
});

export type IQuestionnaireInstance = z.infer<typeof IQuestionnaireInstanceSchema>;

const IAssociatedStatusesSchema = z.object({
    notStarted: z.object({
        activities: z.array(
            z.object({
                activityId: HashedIdSchema,
                points: z.number(),
            })
        ),
        activityCategories: z.array(
            z.object({
                activityCategoryId: HashedIdSchema,
                points: z.number(),
            })
        ),
    }),
    inProgress: z.array(
        z.object({
            activityInstanceId: HashedIdSchema,
            percentage: z.number(),
            points: z.number(),
        })
    ),
    completed: z.array(
        z.object({
            activityInstanceId: HashedIdSchema,
            points: z.number(),
        })
    ),
});

export type IAssociatedStatusesKeys = keyof z.infer<typeof IAssociatedStatusesSchema>;

export type IAssociatedStatuses = z.infer<typeof IAssociatedStatusesSchema>;

const IPointSchema = z.object({
    pointId: HashedIdSchema,

    startedOn: z.string().datetime(),
    endedOn: z.string().datetime(),

    createdOn: z.string().datetime(),
    createdBy: z.string(),

    pointsEarned: z.number().int(),
});

export type IQuestionnairePoint = z.infer<typeof IPointSchema>;
